import React from "react";
import SignIn from "./SingIn";
import SmetaSignIn from "./SmetaSignIn";
import { Card, CardActionArea, CardContent, CardMedia, Divider, Grid } from "@mui/material";
import { useAtomValue } from "jotai";
import { appConfig } from "../../atoms";
import { useNavigate } from "react-router";
import SignInStyles from "./signin.module.css";
import styles from "./signin.module.css";
import clsx from "clsx";

const LkNavigateButton = () => {
  const navigate = useNavigate();

  const onCardClick = () => {
    navigate("/lk");
  };
  return (
    <Grid
      container
      direction="row"
      sx={{
        justifyContent: "center",
        alignItems: "center",
        width: "100%",
      }}
    >
      <Card className={clsx(SignInStyles.cardSignInStyle)}>
        <CardActionArea onClick={onCardClick}>
          <CardMedia component="img" image="logo.png" sx={{ p: 2 }} />
          <CardContent>
            <div className={styles.lkNavigatePanel}>Вход в Личный кабинет</div>
          </CardContent>
        </CardActionArea>
      </Card>
    </Grid>
  );
};

const SignInWrapper = () => {
  const config = useAtomValue(appConfig);

  if (!config?.smeta?.signOptions?.splitSignIn) return config.smeta.newDesign ? <SmetaSignIn /> : <SignIn />;
  return (
    <Grid
      container
      direction="row"
      sx={{
        justifyContent: "center",
        alignItems: "center",
        height: "100%",
      }}
    >
      <Grid sx={{ width: "49.5%" }} className={clsx(styles.wrapperLkButtonContainer)}>
        <LkNavigateButton />
        <div className={clsx(styles.wrapperSmetaText)}>{config.smeta.signOptions.textAboutButtons?.lk}</div>
      </Grid>
      <Grid sx={{ height: "70%" }}>
        <Divider flexItem variant={"fullWidth"} orientation="vertical" sx={{ height: "100%" }} />
      </Grid>
      <Grid sx={{ width: "49.5%" }}>{config.smeta.newDesign ? <SmetaSignIn /> : <SignIn />}</Grid>
    </Grid>
  );
};

export default SignInWrapper;
